import { RADIUS, SURFACE_STRONG } from '@/lib/surface'
import { META, MICRO } from '@/lib/typography'
import { cn } from '@/lib/utils'

/**
 * What pressing the button actually does.
 *
 * Sits immediately above the submit, because that is where the decision
 * happens, and it is deliberately honest about the state of the system: no
 * payment is taken here, no account is created, and the amount is confirmed by
 * a person afterwards. Every line is something the order flow really does.
 */
const STEPS = [
  'Zapisujemy zamówienie i wysyłamy potwierdzenie na Twój e-mail.',
  'Producent odzywa się, żeby ustalić brief i szczegóły realizacji.',
  'Kwotę i sposób płatności potwierdzamy przed startem prac.',
] as const

export function NextStepsNote() {
  return (
    <div className={cn('p-5', RADIUS.box, SURFACE_STRONG)}>
      <p className={cn(MICRO, 'font-semibold tracking-[0.18em] text-white/55 uppercase')}>
        Co dalej
      </p>
      <ul className="mt-3 flex list-none flex-col gap-2.5">
        {STEPS.map((line) => (
          <li
            key={line}
            className={cn(META, 'flex items-start gap-2.5 leading-relaxed text-white/70')}
          >
            <span
              aria-hidden="true"
              className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-white/40"
            />
            {line}
          </li>
        ))}
      </ul>
    </div>
  )
}
